import {
  ListPickupParams,
  ListSttRequestPickupRequest
} from "@/data/payload/api/ListPickupV2Request";
import { RequestListPickupDetail } from "@/domain/entities/ListPickupV2";

export class ListPickupV2Endpoint {
  getListSttRequestPickup(params: ListSttRequestPickupRequest) {
    return `/hydra/v2/stt?${params.toQueryString()}`;
  }
  getPickupCorporateSummary(params: any) {
    return `/hydra/v1/pickup-corporate/summary?${params.toQueryString()}`;
  }
  getListPickupDetail(id: string, params?: RequestListPickupDetail) {
    const endpoint = `/hydra/v1/pickup-corporate/${id}`;
    const queryString = params?.toQueryString();
    return queryString ? `${endpoint}?${queryString}` : endpoint;
  }

  getListPickup(params: ListPickupParams) {
    return `/hydra/v1/pickup-corporate?${params.toQueryString()}`;
  }
}
